import { render, staticRenderFns } from "./Encuestador.vue?vue&type=template&id=32770418&"
import script from "./Encuestador.vue?vue&type=script&lang=js&"
export * from "./Encuestador.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports